/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SegmentedButtonComponent} from './segmented-button.component';

@NgModule({
    imports: [CommonModule],
    declarations: [SegmentedButtonComponent],
    exports: [SegmentedButtonComponent]
})

export class SegmentedButtonModule {
}
